module.exports = __webpack_public_path__ + "img/eyes-02.1802b8bf.svg";